import { useContext } from 'react'
import { AppShell } from '@shared/components/app-shell/app-shell'
import { LogoutLink } from '@/components/shared/logout-link/logout-link'
import { MAIN_MENU_LINKS, stationScopedMenuLinks } from '@/constants/menus'
import { StationContext } from '@/pages/station-context'
import { Logo } from '@/components/shared/logo/logo'

export function AppShellWrapper() {
  const { station } = useContext(StationContext)

  let menuLinks = MAIN_MENU_LINKS
  if (station && station.recordNumber) {
    // If a station is selected, use the station scoped menu links
    menuLinks = stationScopedMenuLinks(station.recordNumber)
  }

  return (
    <AppShell menuLinks={menuLinks} logoComponent={<Logo />} logoutComponent={<LogoutLink />} />
  )
}
